import React from "react";
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import IconMenu from "../../components/subMenu/SubMenu";
import { Paper } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import Users from "./Users";
import NewUser from "./NewUser";
import User from "./User";
import Messages from "./Messages"

const menuHeader = {
  icon: <SettingsOutlinedIcon sx={{ color: "white" }} fontSize="small" />,
  name: "Settings",
};

const menu = [
  { link: "/settings/users", name: "Users" },
  { link: "/settings/roles", name: "Roles" },
  { link: "/settings/permissions", name: "Permissions" },
  { link: "/settings/messages", name: "Messages" },
];

function Settings() {
  return (
    <MiniDrawer>
      {() => (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            height: "100%",
          }}
        >
          <IconMenu menuHeader={menuHeader} menu={menu} />

          <Paper
            sx={{
              width: "100%",
              marginLeft: "20px",
              padding: "20px",
              overflow: "auto",
            }}
          >
            <Routes>
              <Route path="/users" element={<Users />} />{" "}
              <Route path="/users/new-user" element={<NewUser />} />
              <Route path="/users/:userId/user" element={<User />} />
              <Route path="/roles" element={"roles"} />
              <Route path="/permissions" element={"permissions"} />
              <Route path="/messages" element={<Messages />} />
            </Routes>
          </Paper>
        </Box>
      )}
    </MiniDrawer>
  );
}

export default Settings;
